import { useMemo, useRef } from 'react'

import DocumentForm from 'modules/timeoff/lib/DocumentForm'
import LeaveForm from 'modules/timeoff/lib/LeaveForm'
import type Leave from 'modules/timeoff/store/models/Leave'

interface Props {
  leave: Leave
  effectiveOn: string | null | undefined
}
interface ReturnType {
  form: LeaveForm
  documentForm: DocumentForm
}

const useForms = ({ leave, effectiveOn }: Props): ReturnType => {
  const documentForm = useRef(new DocumentForm({}))
  const hoursAmountInCents = leave.hoursAmountInCents
  const delegatedApproverId = leave.delegatedApprover

  const form = useMemo<LeaveForm>(
    () =>
      new LeaveForm({
        ...leave.toJS(),
        effective_on: effectiveOn,
        hours_amount_in_cents: hoursAmountInCents,
        delegated_approver_id: delegatedApproverId,
      }),
    [leave, effectiveOn, hoursAmountInCents, delegatedApproverId]
  )

  return {
    form,
    documentForm: documentForm.current,
  }
}

export default useForms
